import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '~/shared/api/data-ingestion-api'

export function useSubmitPaMatch({ onSuccess }: { onSuccess?: () => void } = {}) {
  const queryClient = useQueryClient()

  return useMutation({
    ...apiClient.submitPaCaseMatchFeedbackDocumentsKeyPatientPaMatchesFeedbackPostMutation(),
    onSuccess: (_, variables) => {
      onSuccess?.()
      queryClient.removeQueries(
        apiClient.getDocumentPatientPaMatchesDocumentsKeyPatientPaMatchesGetOptions({
          path: {
            key: variables.path.key,
          },
        }),
      )
      queryClient.invalidateQueries(
        apiClient.getDocumentAuditTrailDocumentsKeyAuditTrailGetOptions({
          path: {
            key: variables.path.key,
          },
        }),
      )
    },
  })
}
